import actionsReports from "./actions";

export default {
  namespaced: true,
  actions: actionsReports,
};
